export default __webpack_public_path__ + "static/media/EATING-2.a0b9fa28.svg";